import {
  User,
  Building2,
  Mail,
  Phone,
  MessageCircle,
  BriefcaseBusiness,
  Receipt,
  Building,
  MapPin,
  Globe,
  Tags,
  Package,
  Wallet,
  MessageSquareText,
} from "lucide-react";
import React, { useState, useEffect } from "react";
import customizeformApi from "../../api/customizeformApi";
import DynamicField from "./DynamicField";
import { showError, showSuccess } from "../../utils/toastUtils";

const EnquiryForm = () => {
  const formId = "6ac5db8c0358f7c41b400eef";

  const [formData, setFormData] = useState({});
  const [formSchema, setFormSchema] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchForm();
  }, []);

  const fetchForm = async () => {
    try {
      const response = await customizeformApi.customize({ formId });
      // console.log("API Response",response.data);
      setFormSchema(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // console.log("formSchema =>", formSchema);
  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      
      const payload = {
        answers: formData,
      };
      const response = await customizeformApi.createSubmission(formId, payload);
     showSuccess("Your Bulk Enquiry has been submitted Successfully. Our Team will contact you shortly.");
      setFormData({});
    } catch (error) {
       showError("Fill all fields correctly.");
    }
  };

  if (loading) {
    return <div className="text-center py-5">Loading Form...</div>;
  }
  return (
    <>
      <div className="enquiry-form-section">
        <div className="container">
          <div className="enquiry-form-container">
            <div className="row d-flex align-items-center justify-content-center ">
              <div className="col-md-6 col-12 ">
                <div className="enquiry-form-card ">
                  <div className="enquiry-form-header">
                    <span className="enquiry-form-badge">
                      Bulk Orders & Wholesale
                    </span>

                    <h2 className="enquiry-form-title">
                      Request a Bulk Enquiry
                    </h2>

                    <p className="enquiry-form-subtitle">
                      Tell us about your requirements and our sales team will
                      provide the best pricing and delivery options.
                    </p>
                  </div>

                  <form onSubmit={handleSubmit}>
                    <div className="row g-4">
                      {/* Row 1 */}
                      {formSchema?.fields?.map((field) => (
                        <div
                          key={field.key}
                          className={
                            field.type === "textarea"
                              ? "col-12 mb-2"
                              : "col-12 mb-2"
                          }
                        >
                          <div className="enquiry-form-group">
                            <label className="enquiry-form-label">
                              {field.label}

                              {field.required && " *"}
                            </label>
                            <DynamicField
                              field={field}
                              value={formData[field.key]}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      ))}


                      <div className="col-12 text-center">
                        <button type="submit" className="enquiry-form-btn">
                          Submit Bulk Enquiry
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EnquiryForm;
